// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2JARa","dragIcon":"SortableItem_dragIcon__2LZlx","disabled":"SortableItem_disabled___WsnT"};